import type { ConfigType } from '@plone/registry';
import Matomo from '@dpg/akademie/components/Matomo/Matomo';

export default function install(config: ConfigType) {
  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: '',
      component: Matomo,
    },
  ];

  config.settings = {
    ...config.settings,
    supportedLanguages: ['de'],
    matomoSiteId: 11,
    matomoUrlBase: '/matomo/',
  };

  config.settings.DSGVOBanner = {
    ...config.settings.DSGVOBanner,
    tracker: {
      type: 'matomo',
      id: 11,
      urlBase: '/matomo/',
    },
    showBanner: false,
    modules: ['tracking'],
    privacy_url: '/service/datenschutz-einstellungen',
  };

  return config;
}
